import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerSVG = styled.svg`
  width: 20px;
  height: 20px;
  animation: ${spin} 1s linear infinite;
  display: block;
`;

const SpinnerSSE = () => (
  <SpinnerSVG viewBox="0 0 32 32">
    <defs>
      <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1AE276" />
        <stop offset="50%" stopColor="#1CDA81" />
        <stop offset="85%" stopColor="#3A7DFF" />
        <stop offset="95%" stopColor="#fff" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </defs>
    <circle
      cx="16"
      cy="16"
      r="12"
      fill="none"
      stroke="url(#spinner-gradient)"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="50 28"
    />
  </SpinnerSVG>
);

export default SpinnerSSE;
